import api from '../utils/api';

/**
 * Service API pour la gestion des magasins
 */

// Récupérer tous les magasins
export const getAllMagasins = async () => {
    const response = await api.get('/magasins');
    return response.data;
};

// Récupérer un magasin par ID
export const getMagasinById = async (id) => {
    const response = await api.get(`/magasins/${id}`);
    return response.data;
};

// Récupérer les magasins d'un gestionnaire
export const getMagasinsByManager = async (managerId) => {
    const response = await api.get(`/magasins/manager/${managerId}`);
    return response.data;
};

// Récupérer les magasins actifs uniquement
export const getActiveMagasins = async () => {
    const response = await api.get('/magasins/active');
    return response.data;
};

// Créer un nouveau magasin
export const createMagasin = async (magasinData) => {
    const response = await api.post('/magasins', magasinData);
    return response.data;
};

// Mettre à jour un magasin
export const updateMagasin = async (id, magasinData) => {
    const response = await api.put(`/magasins/${id}`, magasinData);
    return response.data;
};

// Supprimer un magasin (soft delete)
export const deleteMagasin = async (id) => {
    const response = await api.delete(`/magasins/${id}`);
    return response.data;
};

// Récupérer les stocks d'un magasin
export const getMagasinStocks = async (id) => {
    const response = await api.get(`/magasins/${id}/stocks`);
    return response.data;
};

// Récupérer le stock total d'un produit (tous magasins)
export const getTotalStockForProduct = async (productId) => {
    const response = await api.get(`/magasins/stocks/product/${productId}/total`);
    return response.data;
};

export default {
    getAllMagasins,
    getMagasinById,
    getMagasinsByManager,
    getActiveMagasins,
    createMagasin,
    updateMagasin,
    deleteMagasin,
    getMagasinStocks,
    getTotalStockForProduct
};